import { Textarea } from "@/components/ui/textarea";
import CustomView from "@/domain/entities/customViews/CustomView";
import useUpdateView from "@/hooks/customView/useUpdateView";
import { Pencil, Save } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import NotesContent from "./NotesContent";

type NotesProps = {
    view: CustomView;
};

const Notes = ({ view }: NotesProps) => {
    const { t } = useTranslation();
    const [localNoteContent, setLocalNoteContent] = useState<string>(
        view.noteContent,
    );
    const [isEditing, setIsEditing] = useState(false);
    const updateView = useUpdateView();

    const handleSaveNotes = async () => {
        const previousNoteContent = view.noteContent;
        view.setNoteContent(localNoteContent);
        const success = await updateView(view);
        if (!success) {
            view.setNoteContent(previousNoteContent);
        }
    };

    useEffect(() => {
        setLocalNoteContent(view.noteContent);
    }, [view]);

    return (
        <Card className="flex flex-col" variant="orange">
            <CardHeader className="mb-0 flex items-center justify-between">
                <CardTitle className="text-lg font-bold">
                    <h2>{t("widgets.notes.title")}</h2>
                </CardTitle>
                {!isEditing && (
                    <Button
                        onClick={() => {
                            setIsEditing(true);
                        }}
                        size="smIcon"
                        variant="ghostWhite"
                    >
                        <Pencil className="h-4 w-4" />
                    </Button>
                )}

                {isEditing && (
                    <Button
                        className="border border-white"
                        onClick={() => {
                            setIsEditing(false);
                            handleSaveNotes();
                        }}
                        size="smIcon"
                        variant="ghostWhite"
                    >
                        <Save className="h-4 w-4" />
                    </Button>
                )}
            </CardHeader>
            <CardContent variant="ghost">
                {!isEditing && (
                    <div>
                        {localNoteContent.length > 0 ? (
                            <NotesContent noteContent={localNoteContent} />
                        ) : (
                            <p>{t("widgets.notes.noNotes")}</p>
                        )}
                    </div>
                )}
                {isEditing && (
                    <Textarea
                        className="h-30 p-0"
                        onChange={(e) => setLocalNoteContent(e.target.value)}
                        value={localNoteContent}
                        variant="invisible"
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default Notes;
